import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { articleList } from '../data/articles';
export function BlogPage() {
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-193">
      <Navigation data-id="element-194" />

      <main className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 pt-28 sm:pt-36 pb-24 sm:pb-32" data-id="element-195">
        <h1 className="text-4xl sm:text-5xl font-semibold text-[#0F0F0F] tracking-tight mb-16" style={{
        fontSize: '36px'
      }} data-id="element-196">
          Blog
        </h1>

        <div className="space-y-0" data-id="element-197">
          {articleList.map((article, index) => <article key={index} className={`py-10 ${index !== 0 ? 'border-t border-[#E8E6E3]' : ''}`} data-id="element-198">
              <div className="flex items-center gap-3 mb-4" data-id="element-199">
                <span className="text-[13px] font-medium text-[#9B9B9B]" data-id="element-200">
                  {article.category}
                </span>
              </div>
              <Link to={`/blog/${article.slug}`} data-id="element-201">
                <h2 className="text-xl sm:text-2xl font-medium text-[#0F0F0F] tracking-tight leading-snug mb-3 hover:text-[#5C5C5C] transition-colors duration-200" data-id="element-202">
                  {article.title}
                </h2>
              </Link>
            </article>)}
        </div>
      </main>

      <Footer data-id="element-203" />
    </div>;
}